import Axios from 'axios'
import { getCookie } from '../utils/auth-utils'

const payments = {
  axios() {
    let AxiosInstance = Axios
    AxiosInstance.defaults.baseURL = process.env.BILLINGS_v2 + '/leia'
    return AxiosInstance
  },
  getPaymentHistory(date) {
    const period = date && date.startDate && date.endDate ? `?startDate=${date.startDate}&endDate=${date.endDate}` : ''
    return this.axios().get(`/payments/history/entity/${getCookie('profile').id_laboratory}${period}`)
  },
  getPaymentById(id) {
    return this.axios().get(`/payments/${id}`)
  },
  getPaymentProof(id) {
    return this.axios().get(`/payments/${id}/proof`)
  },
  getPaymentProofDownload(id) {
    return this.axios().get(`/payments/${id}/proof/download`,
      {
        responseType: "arraybuffer",
      }
    )
  },
  getEntityResume(walletType) {
    return this.axios().get(`/account/entity/${getCookie('profile').id_laboratory}/wallet/${walletType}/resume/aol`)
  },
  getBalance(walletType) {
    return this.axios().get(`/account/entity/${getCookie('profile').id_laboratory}/wallet/${walletType}/balance`)
  },
  findAccountByEntityId(walletType) {
    return this.axios().get(`/account/entity/${getCookie('profile').id_laboratory}/wallet/${walletType}`)
  },
  createRequestPayment(data, accountId) {
    return this.axios().post(`/account/${accountId}/credit`, { ...data, entityId: getCookie('profile').id_laboratory })
  },
  getPaymentStatement(walletType, params) {
    return this.axios().get(`/account/entity/${getCookie('profile').id_laboratory}/wallet/${walletType}/transactions`, {
      params
    })
  }
}

export default payments
